
import { FC, useCallback, useContext, useLayoutEffect, useRef, useState } from "react";
import DruidWebchatContext, { DruidWebchatContextType, WebChatHeaderOptions } from "../../WebChatContext";


import { useMergedOptions } from "../../selectors/useMergedOptions";
import { DruidReloadSelector } from "./DruidReloadSelector";
import { DruidResetSelector } from "./DruidResetSelector";
import { DruidChangeSideSelector } from "./DruidChangeSideSelector";
import IconButton from 'botframework-webchat-component/lib/SendBox/IconButton';

import * as bsIcons from 'react-icons/bs';
import * as faIcons from 'react-icons/fa';
import classNames from "classnames";
import useDruidLocalize from "../../hooks/useDruidLocalize";
import { DruidCustomButton } from "./DruidCustomButton";
import { useWebChatRefsContext } from "../../hooks/useWebChatRefsContext";


export const DruidOptionsContainer = ({ children }) => {

    const [druidWebChatState, , , ] = useContext<DruidWebchatContextType>(DruidWebchatContext);
    const { headerRef } = useWebChatRefsContext();

    const { isWidget,
        UI: {  headerFontSize, accessibilityFeaturesEnabled } = {},
        styleOptions: { } = {}
    } = useMergedOptions();
    const { showChangeSideButton, showReload, showLanguageSelector, showReset } = druidWebChatState.headerOptions;
    const druidLocalize = useDruidLocalize();

    const { DruidLanguageSelector = null } = children || {};


    const [headerMenuOpen, setHeaderMenuOpen] = useState(false);

    const ExpandHeaderMenuIcon = bsIcons["BsGear"];
    const CollapseHeaderMenuIcon = bsIcons["BsCheckLg"];


    const canShowChangeSideButton = !druidWebChatState.isMobile && showChangeSideButton;
    const canShowReset = isWidget && showReset;

    useLayoutEffect(() => {
        if(accessibilityFeaturesEnabled) {
            const buttonElement = headerRef?.querySelector(".druid__webchat__header-toggle-menu");
            if(buttonElement) {
                buttonElement.ariaExpanded = headerMenuOpen.toString();
            }
    
            if (headerMenuOpen) {
                const toFocusButton = headerRef?.querySelector<HTMLButtonElement>(".druid__webchat__header-button");
                toFocusButton?.focus();
            }
        }
    }, [headerRef, headerMenuOpen, accessibilityFeaturesEnabled]);

    return (<>
        {headerMenuOpen &&
            (<>
                {
                    isWidget && showReset && <DruidResetSelector></DruidResetSelector> // not available on isWidget == false
                }
                {
                    showReload && <DruidReloadSelector></DruidReloadSelector>
                }
                {/* {
                    showLanguageSelector && DruidLanguageSelector
                } */}
                {
                    canShowChangeSideButton && <DruidChangeSideSelector />
                }
                {/* { <DruidCustomButton></DruidCustomButton>} */}

            </>)
        }

        <div style={{ paddingLeft: '20px' }} className="druid__webchat__header-menu-padding-element" />
        {
            (showReload || canShowReset || canShowChangeSideButton) && (ExpandHeaderMenuIcon || CollapseHeaderMenuIcon) &&
            (<IconButton
                alt={!headerMenuOpen ? druidLocalize("DRUID_SETTINGS_OPEN_BUTTON_ALT"): druidLocalize("DRUID_SETTINGS_CONFIRM_BUTTON_ALT")}
                className={classNames('druid__webchat__header-button', 'druid__webchat__header-fadeIn', 'druid__webchat__header-toggle-menu')}
                onClick={(e) => { e.stopPropagation(); setHeaderMenuOpen(!headerMenuOpen);}}
            >
                { !headerMenuOpen ? <ExpandHeaderMenuIcon size={headerFontSize!}/> : <CollapseHeaderMenuIcon size={headerFontSize!} /> }
            </IconButton>)
        }
    </>)


}




